function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.25 10.8504H10.15V1.75039C10.15 1.5571 9.99331 1.40039 9.80002 1.40039C4.38761 1.40039 0 5.788 0 11.2004C0 16.6128 4.38761 21.0004 9.80002 21.0004C15.2124 21.0004 19.6 16.6128 19.6 11.2004C19.6 11.0071 19.4433 10.8504 19.25 10.8504ZM9.80002 20.3004C4.77423 20.3016 0.699039 16.2284 0.697814 11.2026C0.696676 6.31129 4.5623 2.29399 9.45002 2.10704V11.2004C9.45002 11.3937 9.60673 11.5504 9.80002 11.5504H18.8934C18.6994 16.4338 14.6873 20.2945 9.80002 20.3004Z",
  fill: "#22A7F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1996 0C11.0063 0 10.8496 0.156713 10.8496 0.350001V9.80002C10.8496 9.99331 11.0063 10.15 11.1996 10.15H20.6496C20.8429 10.15 20.9996 9.99331 20.9996 9.80002C20.9935 4.39019 16.6094 0.00616876 11.1996 0ZM11.5496 9.45002V0.706651C16.298 0.895608 20.104 4.70165 20.293 9.45002H11.5496Z",
  fill: "#22A7F0"
});

var SvgSurveysIcon = function SvgSurveysIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurveysIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/surveys-icon.0ea0c8f3.svg";
export { ForwardRef as ReactComponent };